const REGISTERED: Record<string, string> = {
  'skipvisaqueue.com.br': 'SKIP VISA QUEUE LTDA · CNPJ 66.707.014/0001-58',
};

function apexHost(host: string): string {
  return Object.keys(REGISTERED).find(
    (apex) => host === apex || host.endsWith(`.${apex}`),
  ) ?? host;
}

export function getLegalEntity(host: string = window.location.hostname): string | null {
  return REGISTERED[apexHost(host.toLowerCase())] ?? null;
}
